import React from "react";
import QueueIcon from "@mui/icons-material/Queue";
import { Button, useRecordContext, useRedirect } from "react-admin";
import dataProvider from "server/dataProvider";
import { EXAM_COMMITTIEES, SpecialistServicePath } from "utils/constants";

const CloneExamCommitteeButton = ({ label = "Клонирай" }) => {
  const record = useRecordContext();
  const redirect = useRedirect();

  const handleClick = () => {
    if (!record) return;
    dataProvider.getOne(`${SpecialistServicePath}${EXAM_COMMITTIEES}`, { id: record?.id }).then(({ data }) => {
      const cleaned = {
        ...data,
        name: null,
      };
      const source = encodeURIComponent(JSON.stringify(cleaned));
      redirect(`/${SpecialistServicePath}${EXAM_COMMITTIEES}/create?source=${source}`);
    });
  };

  return (
    <Button
      label={label}
      startIcon={<QueueIcon />}
      onClick={handleClick}
    />
  );
};

export default CloneExamCommitteeButton;
